import React, { useEffect, useRef, useState } from 'react';
import { JAVA, PYTHON } from '../utils/common_utils';

const languages = [JAVA, PYTHON];

function JavaIcon({ className = "h-7 w-7" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#F44336"
        d="M23.65,24.898c-0.998-1.609-1.722-2.943-2.725-5.455C19.229,15.2,31.24,11.366,26.37,3.999c2.111,5.089-7.577,8.235-8.477,12.473C17.07,20.37,23.645,24.898,23.65,24.898z"
      />
      <path
        fill="#F44336"
        d="M23.878,17.27c-0.192,2.516,2.229,3.857,2.299,5.695c0.056,1.496-1.447,2.743-1.447,2.743s2.728-0.536,3.579-2.818c0.945-2.534-1.834-4.269-1.548-6.298c0.267-1.938,6.031-5.543,6.031-5.543S24.311,11.611,23.878,17.27z"
      />
      <g>
        <path
          fill="#1565C0"
          d="M32.084 25.055c1.754-.394 3.233.723 3.233 2.01 0 2.901-4.021 5.643-4.021 5.643s6.225-.742 6.225-5.505C37.521 24.053 34.464 23.266 32.084 25.055zM29.129 27.395c0 0 1.941-1.383 2.458-1.902-4.763 1.011-15.638 1.147-15.638.269 0-.809 3.507-1.638 3.507-1.638s-7.773-.112-7.773 2.181C11.683 28.695 21.858 28.866 29.129 27.395z"
        />
        <path
          fill="#1565C0"
          d="M27.935,29.571c-4.509,1.499-12.814,1.02-10.354-0.993c-1.198,0-2.974,0.963-2.974,1.889c0,1.857,8.982,3.291,15.63,0.572L27.935,29.571z"
        />
        <path
          fill="#1565C0"
          d="M18.686,32.739c-1.636,0-2.695,1.054-2.695,1.822c0,2.391,9.76,2.632,13.627,0.205l-2.458-1.632C24.271,34.404,17.014,34.579,18.686,32.739z"
        />
        <path
          fill="#1565C0"
          d="M36.281,36.632c0-0.936-1.055-1.377-1.433-1.588c2.228,5.373-22.317,4.956-22.317,1.784c0-0.721,1.807-1.427,3.477-1.093l-1.42-0.839C11.26,34.374,9,35.837,9,37.017C9,42.52,36.281,42.255,36.281,36.632z"
        />
        <path
          fill="#1565C0"
          d="M39,38.604c-4.146,4.095-14.659,5.587-25.231,3.057C24.341,46.164,38.95,43.628,39,38.604z"
        />
      </g>
    </svg>
  );
}

function PythonIcon({ className = "h-7 w-7" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#0277bd"
        d="M24.047,5c-1.555,0.005-2.633,0.142-3.936,0.367c-3.848,0.67-4.549,2.077-4.549,4.67V14h9v2H15.22h-4.35c-2.636,0-4.943,1.242-5.674,4.219c-0.826,3.417-0.863,5.557,0,9.125C5.851,32.005,7.294,34,9.931,34h3.632v-5.104c0-2.966,2.686-5.896,5.764-5.896h7.236c2.523,0,5-1.862,5-4.377v-8.586c0-2.439-1.759-4.263-4.218-4.672C27.406,5.359,25.589,4.994,24.047,5z M19.063,9c0.821,0,1.5,0.677,1.5,1.502c0,0.833-0.679,1.498-1.5,1.498c-0.837,0-1.5-0.664-1.5-1.498C17.563,9.68,18.226,9,19.063,9z"
      />
      <path
        fill="#ffc107"
        d="M23.078,43c1.555-0.005,2.633-0.142,3.936-0.367c3.848-0.67,4.549-2.077,4.549-4.67V34h-9v-2h9.343h4.35c2.636,0,4.943-1.242,5.674-4.219c0.826-3.417,0.863-5.557,0-9.125C41.274,15.995,39.831,14,37.194,14h-3.632v5.104c0,2.966-2.686,5.896-5.764,5.896h-7.236c-2.523,0-5,1.862-5,4.377v8.586c0,2.439,1.759,4.263,4.218,4.672C19.719,42.641,21.536,43.006,23.078,43z M28.063,39c-0.821,0-1.5-0.677-1.5-1.502c0-0.833,0.679-1.498,1.5-1.498c0.837,0,1.5,0.664,1.5,1.498C29.563,38.32,28.899,39,28.063,39z"
      />
    </svg>
  );
}

function CodeIcon({ className = "h-7 w-7" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 9L5 12l3 3"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9l3 3-3 3"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 7l-3 10"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
    </svg>
  );
}

function DropdownArrowIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      viewBox="0 0 20 20"
      className={className}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
    >
      <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" />
    </svg>
  );
}

function CheckIcon({ className = "h-4 w-4" }) {
  return (
    <svg
      viewBox="0 0 20 20"
      className={className}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.414 0L3.296 9.216a1 1 0 111.414-1.414l4.037 4.037 6.543-6.55a1 1 0 011.414 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function getLanguageLabel(lang) {
  if (!lang || lang.length === 0) return '';
  return lang[0].toUpperCase() + lang.slice(1);
}

function LanguageIcon({ lang, className = "h-8 w-8" }) {
  const normalized = (lang || '').toLowerCase();

  if (normalized === JAVA) {
    return <JavaIcon className={className} />;
  }

  if (normalized === PYTHON) {
    return <PythonIcon className={className} />;
  }

  return <CodeIcon className={className} />;
}

function LanguageIconBox({ lang, selected = false }) {
  const normalized = (lang || '').toLowerCase();

  let colorClass = "bg-slate-50 text-slate-600 ring-slate-200";
  if (normalized === JAVA) {
    colorClass = "bg-orange-50 ring-orange-100";
  } else if (normalized === PYTHON) {
    colorClass = "bg-blue-50 ring-blue-100";
  }

  return (
    <span
      className={`
        flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl
        ring-1 transition
        ${colorClass}
        ${selected ? "shadow-sm" : ""}
      `}
      aria-hidden="true"
    >
      <LanguageIcon lang={lang} />
    </span>
  );
}

const SelectLanguageDropdown = ({
  language,
  availableLanguages = languages,
  onLanguageChange
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedLanguage(language);
  }, [language]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const handleChange = (lang) => {
    setSelectedLanguage(lang);
    setOpen(false);

    if (onLanguageChange) {
      onLanguageChange(lang); // Call provided callback if available
    }
  };

  return (
    <div
      ref={dropdownRef}
      className="relative inline-block w-full min-w-[200px] sm:min-w-[220px] max-w-sm"
    >
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="
          flex w-full items-center justify-between gap-3 rounded-2xl
          border border-slate-200 bg-white px-3 py-2.5 text-left
          shadow-sm transition-all duration-200
          hover:border-slate-300 hover:bg-slate-50 hover:shadow-md
          focus:outline-none focus:ring-4 focus:ring-indigo-100
        "
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex min-w-0 items-center gap-3">
          <LanguageIconBox lang={selectedLanguage} selected />

          <span className="truncate text-base font-semibold text-slate-800 md:text-lg">
            {getLanguageLabel(selectedLanguage)}
          </span>
        </span>

        <span
          className={`
            flex h-8 w-8 shrink-0 items-center justify-center rounded-full
            bg-slate-100 text-slate-500 transition
            ${open ? "rotate-180 bg-indigo-50 text-indigo-600" : ""}
          `}
        >
          <DropdownArrowIcon />
        </span>
      </button>

      {open && (
        <div
          className="
            absolute left-0 right-0 z-50 mt-2 overflow-hidden rounded-2xl
            border border-slate-200 bg-white p-1.5 shadow-xl
          "
          role="listbox"
        >
          {availableLanguages.map((lang) => {
            const isSelected = lang === selectedLanguage;

            return (
              <button
                type="button"
                key={lang}
                onClick={() => handleChange(lang)}
                className={`
                  flex w-full items-center gap-3 rounded-xl px-3 py-2.5
                  text-left transition
                  ${isSelected
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-slate-700 hover:bg-slate-50"
                  }
                `}
                role="option"
                aria-selected={isSelected}
              >
                <LanguageIconBox lang={lang} selected={isSelected} />

                <span className="min-w-0 flex-1 truncate text-base font-semibold">
                  {getLanguageLabel(lang)}
                </span>

                {isSelected && (
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                    <CheckIcon />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export {
  SelectLanguageDropdown,
  JavaIcon,
  PythonIcon,
  CodeIcon,
  DropdownArrowIcon,
  CheckIcon,
  LanguageIcon,
  LanguageIconBox
};